import { AuthConfig } from "@digital-services/shell";

export const authConfigOnly: AuthConfig = {
  clientId: import.meta.env.VITE_APP_CLIENT_ID as string,
  authority: import.meta.env.VITE_APP_AUTHORITY as string
};
